// extracted by mini-css-extract-plugin
export default {"header":"Table_header__yM-Bs","link":"Table_link__9peYr","active":"Table_active__vSxUs","inactive":"Table_inactive__3pa9-"};